import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

interface ConfirmData {
  header?: string;
  message?: string;
  icon?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptIcon?: string;
  rejectIcon?: string;
  accept: () => any;
  reject?: () => any;
}

/** Глобальные классы кнопок — стили в `crm-theme.scss` (Modal / Dialog v2). */
const CONFIRM_ACCEPT_BUTTON_CLASS = 'frm-confirm-dialog-v2__accept';
const CONFIRM_REJECT_BUTTON_CLASS = 'frm-confirm-dialog-v2__reject';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  public constructor(private readonly confirmationService: ConfirmationService) {}

  public confirm(data: ConfirmData) {
    this.confirmationService.confirm({
      message: data.message || '',
      header: data.header ?? 'Подтверждение действия',
      icon: data.icon ?? 'pi pi-info-circle',
      acceptLabel: data.acceptLabel ?? 'Да',
      rejectLabel: data.rejectLabel ?? 'Нет',
      acceptIcon: data.acceptIcon ?? 'pi pi-check',
      rejectIcon: data.rejectIcon ?? 'pi pi-times',
      acceptButtonStyleClass: CONFIRM_ACCEPT_BUTTON_CLASS,
      rejectButtonStyleClass: CONFIRM_REJECT_BUTTON_CLASS,
      defaultFocus: 'accept',
      accept: data.accept || (() => null),
      reject: data.reject || (() => null)
    });
  }
}
